export default {
  data() {
    return {
      monthlyPrice: null,
      monthlyWasPrice: null,
      monthlyDiscount: null,
      oneTimePrice: null,
      oneTimeWasPrice: null,
      oneTimeDiscount: null,
    };
  },
  methods: {
    retrievePrice(priceObj) {
      let monthlyPrice;
      let monthlyWasPrice;
      let monthlyDiscount;
      let oneTimePrice;
      let oneTimeWasPrice;
      let oneTimeDiscount;

      priceObj.forEach((item) => {
        switch (item.paymentFrequency) {
          case 'ONETIME':
            if (item.type === 'DEFAULT') {
              oneTimePrice = item.amount;
            }
            if (item.type === 'WAS') {
              oneTimeWasPrice = item.amount;
            }
            break;
          case 'MONTHLY':
            if (item.type === 'DEFAULT') {
              monthlyPrice = item.amount;
            }
            if (item.type === 'WAS') {
              monthlyWasPrice = item.amount;
            }
            break;
          default:
            break;
        }
      });

      if (oneTimePrice && oneTimeWasPrice) {
        oneTimeDiscount = 100 - Math.floor((oneTimePrice / oneTimeWasPrice) * 100);
      }
      if (monthlyPrice && monthlyWasPrice) {
        monthlyDiscount = 100 - Math.floor((monthlyPrice / monthlyWasPrice) * 100);
      }

      this.oneTimePrice = oneTimePrice;
      this.oneTimeWasPrice = oneTimeWasPrice;
      this.oneTimeDiscount = oneTimeDiscount;
      this.monthlyPrice = monthlyPrice;
      this.monthlyWasPrice = monthlyWasPrice;
      this.monthlyDiscount = monthlyDiscount;
    },
  },
};
